"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectProcessor = void 0;
const EffectTracker_1 = require("./EffectTracker");
const ScriptEvaluator_1 = require("./ScriptEvaluator");
class EffectProcessor {
    /**
     * Process an effect script
     */
    static process(effectScript, player, gameSession, variableStore, adventureManager, friendsService, adventureInviteService, asyncOperationService, inviteLinkServiceOrEmail, emailService, emailActionTokenService, verificationCodeService, analyticsService, sharedVariablesService, guestAdventureService, entitiesService, foreignEntityLookup) {
        if (!effectScript) {
            return (0, EffectTracker_1.emptyEffectResult)();
        }
        try {
            // Execute the effect script
            const result = ScriptEvaluator_1.ScriptEvaluator.executeEffects(effectScript, player, gameSession, variableStore, adventureManager, friendsService, adventureInviteService, asyncOperationService, inviteLinkServiceOrEmail, emailService, emailActionTokenService, verificationCodeService, analyticsService, sharedVariablesService, guestAdventureService, entitiesService || foreignEntityLookup
                ? {
                    ...(entitiesService ? { entitiesService } : {}),
                    ...(foreignEntityLookup ? { foreignEntityLookup } : {})
                }
                : undefined);
            return result;
        }
        catch (error) {
            console.error(`❌ EffectProcessor.process failed for script "${effectScript}":`, error);
            throw error;
        }
    }
}
exports.EffectProcessor = EffectProcessor;
//# sourceMappingURL=EffectProcessor.js.map